define(['jquery'], function ($) {

    var FORMS_SCROLL_TOP_OFFSET = 70;

    var EpiserverFormsHelpers = function () {

        var self = this;

        self.selectors = {
            get $fileUploadWrapper() {
                return $('.FormFileUpload');
            },
            get $fileUploadInput() {
                return $('.FormFileUpload__Input');
            },
            get $fileUploadFakeInputInnerWrapper() {
                return $('.FormFileUpload__FakeInput__InnerWrapper');
            },
        }

        self.handleFileInputChange = function() {
            self.selectors.$fileUploadWrapper.each(function() {
                var $input = $(this).find(self.selectors.$fileUploadInput);
                var $fakeInput = $(this).find(self.selectors.$fileUploadFakeInputInnerWrapper);
                var labelText = $(this).data('label-text') || '';

                function handleFileInputModification() {
                    if (!$input[0].files.length) {
                        return $fakeInput.text(labelText);
                    }
                    return $fakeInput.text($.map($input[0].files, function (file) { return file.name }).join(', '));
                }

                $input.on('change', handleFileInputModification);
                $input.closest('form').on('reset', function () {
                    $input.value = '';
                    setTimeout(handleFileInputModification);
                });
            });
        }

        self.scrollToTheTopOfForm = function ($workingForm) {
            if ($workingForm != null && ($workingForm.css("position").toLowerCase() !== "fixed") && ($(document).scrollTop() > 0)) {
                window.scrollTo(0, (($workingForm.offset().top - FORMS_SCROLL_TOP_OFFSET)) || 0);
            }
        }

        self.adjustScrollByTheTopOffset = function () {
            window.scrollBy(0, -FORMS_SCROLL_TOP_OFFSET);
        }

        self.adjustWindowScrollTop = function() {
            if (typeof $$epiforms !== 'undefined') {
                var $form = $$epiforms(".EPiServerForms")

                $form.on("formsSubmitted formsNavigateToStep", function (event) {
                    setTimeout(function() {
                        self.scrollToTheTopOfForm($(event.target))
                    });
                });

                $form.on("formsStepValidating", function (event) {
                    setTimeout(function () {
                        /**
                         * At this time window is already scrolled to first element by default EpiForms method
                         */
                        if ($(event.target).first('.Form__Element.ValidationFail').length) {
                            self.adjustScrollByTheTopOffset()
                        }
                    });
                });
            }
        }
    };

    EpiserverFormsHelpers.prototype.init = function () {
        this.handleFileInputChange();
        this.adjustWindowScrollTop();
    }

    return EpiserverFormsHelpers;
});